import React from 'react';
import { RiArrowGoBackLine } from 'react-icons/ri';
import { usePreferences } from '../../contexts/PreferencesContext';

const ModuleTabChooser = ({
    activeTab,
    modules = [],
    onSelect,
    onBack,
    title,
}) => {
    const { t } = usePreferences();
    const visibleModules = modules.filter(Boolean);
    const activeModule = visibleModules.find((module) => module.id === activeTab);
    const chooserTitle = title || t('chooseOption');

    if (activeTab === -1 || activeModule == null) {
        return (
            <div className="modules-container module-tab-chooser">
                <h5 className="section-title">{chooserTitle}</h5>
                <div className="modules-grid">
                    {visibleModules.map((module) => (
                        <div
                            key={module.id}
                            className="module-card"
                            onClick={() => onSelect(module.id)}
                        >
                            <div className="module-icon">
                                {module.icon ?? module.title?.charAt(0)}
                            </div>
                            <div>
                                <h6>{module.title}</h6>
                                {module.description && <p>{module.description}</p>}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    return (
        <div className="module-tab-active-header">
            <button type="button" className="btn-back-modern" onClick={onBack}>
                <RiArrowGoBackLine />
                {t('back')}
            </button>
            <div>
                <span>{t('viewing')}</span>
                <strong>{activeModule.title}</strong>
            </div>
        </div>
    );
};

export default ModuleTabChooser;
